function changeDateFormat(date) {
  var mydate = new Date(date);
  var month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ][mydate.getMonth()];
  var str = mydate.getDate() + "-" + month + "-" + mydate.getFullYear();
  return str;
}
module.exports = {
  changeDateFormat,
};
